import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Home.module.scss";
import CustomButton from "../../components/CustomButton";

import { VscArrowSwap } from "react-icons/vsc";
import { RiRadioButtonFill } from "react-icons/ri";
import { MdCurrencyRupee } from "react-icons/md";
import { MdAddShoppingCart } from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";
import { MdOutlineSip } from "react-icons/md";
import { IoMdLogOut } from "react-icons/io";

import { MdOutlineFactCheck } from "react-icons/md";
import { MdOutlineDonutSmall } from "react-icons/md";
import SipCalculator from "../../components/SipCalculator";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { portfolioApi } from "../../redux/features/portfolio/portfolioSlice";
import Swal from "sweetalert2";
import Tab from "../../components/common/Tab";

const tabsData = [
  {
    label: "In Rupees",
    value: "inRupees",
  },
  {
    label: "In Grams",
    value: "inGrams",
  },
];

const testData = [
  {
    name: "BUY",
    icon: <MdAddShoppingCart color="#da2128" size={30} />,
    link: "/dashboard/gold/buy",
  },
  {
    name: "SELL",
    icon: <IoMdLogOut color="#da2128" size={30} />,
    link: "/dashboard/gold/sell",
  },
  {
    name: "SIP",
    icon: <MdOutlineSip color="#da2128" size={30} />,
    link: "/dashboard/gold/sip",
  },
  {
    name: "DELIVER",
    icon: <TbTruckDelivery color="#da2128" size={30} />,
    link: "/dashboard/gold/delivery",
  },
];

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isGold, setIsGold] = useState(true);
  const [isRupees, setIsRupees] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [calValue, setCalValue] = useState({
    amount: "100",
    quantity: "",
  });

  const token = sessionStorage.getItem("token");

  const goldLivePrice = useSelector((state) => state.goldSlice.data.data);
  const { data } = useSelector((state) => state.portfolioSlice);

  const goldInLocker = data?.[0]?.augmont?.gold?.balQuantity || "";

  useEffect(() => {
    // dispatch(getGoldApi());
    const token = sessionStorage.getItem("token");
    if (token) dispatch(portfolioApi());
  }, [dispatch]);

  const { gBuy, sBuy } = goldLivePrice?.[0]?.[0] || [];

  var maxQty = "";

  useEffect(() => {
    const x = 1000000 / 1.03;
    const livePrice = isGold ? gBuy : sBuy;
    maxQty = Math.floor(x / livePrice);

    // setQtyError(`Maximum purchase of ${maxQty}gm`);
  }, [isGold, calValue.amount]);

  const handleCalChange = (e) => {
    let input = e.target.value;

    // Prevent negative
    if (input.startsWith("-")) return;

    // Allow only numbers and one dot
    if (!/^\d*\.?\d*$/.test(input)) return;

    // Prevent leading zeros like 0005, but allow 0.5
    if (input.length > 1 && input.startsWith("0") && !input.startsWith("0.")) {
      input = String(parseFloat(input) || 0);
    }

    // Limit decimal places
    if (input.includes(".")) {
      const [intPart, decPart] = input.split(".");
      const maxDecimals = !isRupees ? 3 : 2; // 3 for grams, 2 for rupees
      if (decPart.length > maxDecimals) {
        return; // Prevent typing more than allowed decimals
      }
    }

    setCalValue((prev) => {
      const livePrice = isGold ? gBuy : sBuy;

      if (!isRupees) {
        // user typing in Grams
        const value = parseFloat(input);
        const x = 1000000 / 1.03;
        const maxQty = Math.floor(x / livePrice);

        if (!isNaN(value) && value > maxQty) return prev;

        return {
          ...prev,
          quantity: input === "" ? "0" : input,
          amount: input === "" ? "0" : (value * livePrice).toFixed(2),
        };
      } else {
        // user typing in Rupees
        const value = parseFloat(input);
        if (!isNaN(value) && value > 1000000) return prev;

        return {
          ...prev,
          amount: input === "" ? "0" : input,
          quantity: input === "" ? "0" : (value / livePrice).toFixed(3),
        };
      }
    });
  };

  const handleBlur = (field) => {
    setCalValue((prev) => ({
      ...prev,
      [field]: prev[field] === "" ? "0" : prev[field],
    }));
  };

  // const handleCalChange = (e) => {
  //   const value = parseFloat(e.target.value) || 0; // ensures number input

  //   if (isRupees) {
  //     const x = 1000000 / 1.03;
  //     const livePrice = isGold ? gBuy : sBuy;
  //     maxQty = Math.floor(x / livePrice);
  //     if (value > maxQty) {
  //       return;
  //     }
  //   }

  //   if (value > 1000000) {
  //     return;
  //   }

  //   if (!isRupees) {
  //     setCalValue((prev) => ({
  //       ...prev,
  //       amount: value.toString(),
  //       quantity: (value / (isGold ? gBuy : sBuy) || 0).toFixed(4),
  //     }));
  //   } else {
  //     setCalValue((prev) => ({
  //       ...prev,
  //       amount: (value * (isGold ? gBuy : sBuy) || 0).toFixed(2),
  //       quantity: value.toString(),
  //     }));
  //   }
  // };

  const handleBuy = async () => {
    if (calValue.amount < 100) {
      toast.error("Minimum purchase amount is ₹100");
      return;
    } else if (calValue.amount > 1000000) {
      toast.error("Maximum purchase amount is ₹1000000");
      return;
    }
    const token = sessionStorage.getItem("token");
    const link = isGold
      ? "/dashboard/gold-buy-summary"
      : "/dashboard/silver-buy-summary";
    if (token) {
      try {
        const requestBody = {
          metalType: isGold ? "gold" : "silver",
          ...(isRupees
            ? { amount: calValue.amount }
            : { quantity: calValue.quantity }),
        };

        const response = await axiosInstance.post(
          "/augmont/get-quote-buy",
          requestBody
        );
        navigate(link, {
          state: {
            key: "augmont",
            data: response.data,
          },
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      navigate("/login", {
        state: {
          isAmount: isRupees,
          amount: calValue.amount || "",
          redirectTo: isGold ? "/dashboard/gold/buy" : "/dashboard/silver/buy",
        },
      });
    }
  };

  const handleDelivery = () => {
    const token = sessionStorage.getItem("token");

    if (token) {
      if (goldInLocker) {
        navigate("/dashboard/gold/delivery");
      } else {
        Swal.fire({
          title: "Insufficient Gold",
          text: "You don't have enough gold in your locker to proceed with delivery.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
      }
    } else {
      sessionStorage.setItem("redirectTo", "/dashboard/gold/delivery");
      navigate("/login");
    }
  };

  useEffect(() => {
    if (gBuy && sBuy) {
      const initialAmount = parseFloat(calValue.amount);
      const initialQty = parseFloat(calValue.quantity);
      const rate = isGold ? gBuy : sBuy;

      if (isRupees) {
        setCalValue((prev) => ({
          ...prev,
          quantity: (initialAmount / rate).toFixed(3),
        }));
      } else {
        setCalValue((prev) => ({
          ...prev,
          amount: (initialQty * rate).toFixed(2),
        }));
      }
    }
  }, [gBuy, sBuy, isRupees, isGold]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      navigate("/account");
    }
  }, [navigate]);

  const [minMaxQty, setMinMaxQty] = useState({
    minQty: "",
    maxQty: "",
  });

  useEffect(() => {
    const livePrice = isGold ? gBuy : sBuy;

    const minQty = (100 / livePrice).toFixed(3);

    const x = 1000000 / 1.03;
    const maxQty = Math.floor(x / livePrice);

    setMinMaxQty({
      minQty,
      maxQty,
    });
  }, [isGold, gBuy, sBuy]);

  return (
    <main className={styles.home_Container}>
      {/* SECTION1==== */}
      <section style={{ position: "relative", overflow: "hidden" }}>
        {/* Background mandalas======  */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img
            src="/images/augmandala.webp"
            alt="mandala"
            className={`${styles.sec1_mandala} ${styles.sec1_left_mandala}`}
          />
          <img
            src="/images/augmandala.webp"
            alt="mandala"
            className={`${styles.sec1_mandala} ${styles.sec1_right_mandala}`}
          />
        </div>
        <div className={`${styles.sec1} universal_container`}>
          <div className={styles.sec1_box1}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <h1>
                Invest in Gold & Silver,
                <br />
                Starting Small.
              </h1>
              <p>
                {/* With the trusted name of BajajCapital, explore options to buy */}
                {/* With the trusted name of Tiger Fintech,  */}
                Explore options to buy
                24K BIS/NABH hallmarked Gold and Silver online, from just{" "}
                <strong>₹100</strong>
              </p>
            </div>
            {/* List====  */}
            <div
              style={{
                display: "flex",
                gap: "0.5rem",
                justifyContent: "space-between",
              }}
            >
              <ul className={styles.sec1_list}>
                <li style={{ marginBottom: "30px" }}>
                  <MdCurrencyRupee size={24} color="#da2128" /> Login & enter
                  your amount
                </li>
                <li style={{ marginBottom: "30px" }}>
                  <MdOutlineFactCheck size={24} color="#da2128" /> Complete KYC
                </li>
                <li>
                  <MdOutlineDonutSmall size={24} color="#da2128" /> Pay with
                  ease
                </li>
              </ul>
              {/* <div>
                <img
                  src="/images/testImg.png"
                  alt="people"
                  className={styles.sec1_people_img}
                />
              </div> */}
            </div>
          </div>
          {/* CALCULATOR========  */}
          <div className={`${styles.sec1_cal} universal_card`}>
            <div style={{ display: "flex" }}>
              <button
                style={{
                  width: "100%",
                  padding: "8px 24px",
                  border: "none",
                  borderRadius: "8px",
                  backgroundColor: isGold ? "#fffaee" : "transparent",
                  color: "#bd9300",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                  alignItems: "center",
                }}
                onClick={() => setIsGold(true)}
              >
                <RiRadioButtonFill size={20} />
                Gold
              </button>
              <button
                style={{
                  width: "100%",
                  padding: "8px 24px",
                  border: "none",
                  borderRadius: "8px",
                  backgroundColor: !isGold ? "#e4e4e4" : "transparent",
                  color: "#655f5f",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                  alignItems: "center",
                }}
                onClick={() => setIsGold(false)}
              >
                <RiRadioButtonFill size={20} />
                Silver
              </button>
            </div>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                borderRadius: "8px",
                padding: "1.5rem 1rem",
              }}
            >
              {/* <Tab
                tabs={tabsData}
                activeValue={isRupees ? "inRupees" : "inGrams"}
                onTabChange={(value) => setIsRupees(value === "inRupees")}
              /> */}

              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "end",
                }}
              >
                {/* Input Field=== */}
                <div>
                  <div style={{ fontSize: "12px", marginBottom: "8px" }}>
                    <strong>
                      {!isRupees ? "In Grams (g)" : "In Rupees (₹)"}
                    </strong>
                  </div>
                  <input
                    type="text"
                    value={isRupees ? calValue.amount : calValue.quantity}
                    onChange={handleCalChange}
                    onBlur={() => handleBlur(isRupees ? "amount" : "quantity")}
                    className={styles.sec1_cal_input}
                  />
                </div>
                {/* Switch Btn==== */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#f3f2ee",
                      fontSize: "12px",
                      borderRadius: "50%",
                      padding: "13px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                      border: "1px solid #cfcece",
                    }}
                    onClick={() => setIsRupees(!isRupees)}
                  >
                    <VscArrowSwap size={20} fontWeight={900} />
                  </button>
                  {/* <button
                    style={{
                      backgroundColor: "#f3f2ee",
                      borderRadius: "50%",
                      padding: "13px",
                      display: "flex",
                      justifyContent: "center",
                      border: "none",
                    }}
                    onClick={() => setIsRupees(!isRupees)}
                  >
                    <VscArrowSwap size={20} fontWeight={900} />
                  </button> */}
                </div>
                {/* Input Field=== */}
                <div>
                  <div style={{ fontSize: "12px", marginBottom: "8px" }}>
                    <strong>
                      {isRupees ? "In Grams (g)" : "In Rupees (₹)"}
                    </strong>
                  </div>
                  {/* <input
                    type="text"
                    value={
                      !isRupees
                        ? calValue.quantity
                        : Math.round(calValue.amount)
                    }
                    readOnly
                    className={styles.sec1_cal_input}
                  /> */}
                  <input
                    type="text"
                    value={
                      isRupees
                        ? calValue.quantity || "0"
                        : calValue.amount || "0"
                    }
                    readOnly
                    style={{
                      outline: "none",
                      pointerEvents: "none",
                      // border: "none",
                      // background: "transparent",
                    }}
                    className={styles.sec1_cal_input}
                  />
                </div>
              </div>

              {/* <div style={{ margin: "1rem 0", fontSize: "12px" }}>
                <div>
                  <strong>Min Purchase:</strong> ₹100 / {minMaxQty.minQty || ""}
                  gm
                </div>
                <div>
                  <strong>Max Purchase:</strong> {minMaxQty.maxQty || ""}gm /
                  ₹1000000
                </div>
              </div> */}

              {/* <div
                style={{
                  margin: "1rem 0",
                  fontSize: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "0.5rem",
                }}
              >
                <div>
                  <strong>Min Purchase:</strong>{" "}
                  {isRupees ? "₹100" : `${minMaxQty.minQty || ""}gm`}
                </div>
                <div>
                  <strong>Max Purchase:</strong>{" "}
                  {isRupees ? "  ₹1000000" : `${minMaxQty.maxQty || ""}gm`}
                </div>
              </div> */}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "26px",
                }}
              >
                {[100, 500, 1000, 5000].map((val, index) => {
                  const gramValue = index + 1;
                  const valueToSet = isRupees ? val : gramValue.toString();

                  const handleClick = () => {
                    setActiveIndex(index);
                    if (isRupees) {
                      setCalValue({
                        amount: valueToSet,
                        quantity: (val / (isGold ? gBuy : sBuy) || 0).toFixed(
                          3
                        ),
                      });
                    } else {
                      setCalValue({
                        amount: (
                          valueToSet * (isGold ? gBuy : sBuy) || 0
                        ).toFixed(2),
                        quantity: valueToSet,
                      });
                    }
                  };

                  return (
                    <button
                      key={index}
                      onClick={handleClick}
                      style={{
                        border: "1px solid #DA2128",
                        color: activeIndex === index ? "#fff" : "#DA2128",
                        backgroundColor:
                          activeIndex === index ? "#DA2128" : "transparent",
                        width: "100%",
                        borderRadius: "24px",
                        padding: "5px",
                        fontSize: "14px",
                        fontWeight: "500",
                        transition: "all 0.3s ease-in-out", // smooth transition
                      }}
                    >
                      {isRupees ? `₹${val}` : `${gramValue}g`}
                    </button>
                  );
                })}
              </div>
            </div>
            <p style={{ fontSize: "12px" }}>
              {isGold
                ? "Own pure 24K BIS/NABL hallmarked gold online, anytime, anywhere. Allowed purchase range: ₹100 to ₹10 Lakh."
                : "Get 99.9% pure BIS/NABL hallmarked silver with complete convenience. Allowed purchase range: ₹100 to ₹10 Lakh."}
            </p>
            {/* <p style={{ fontSize: "12px" }}>
              {isGold
                ? "Own pure 24K BIS/NABL hallmarked gold online, anytime, anywhere"
                : "Get 99.9% pure BIS/NABL hallmarked silver with complete convenience"}
            </p> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CustomButton label="Buy Now" onClick={handleBuy} />
            </div>
          </div>
        </div>
        {/* PeopleIMG=====  */}
        <div style={{ position: "relative" }} className="universal_container">
          <img
            // src="/images/testImg.png"
            src="/images/people.png"
            alt="people"
            className={styles.sec1_people_img}
          />
        </div>
      </section>
      {/* SECTION2==== */}
      <section
        className={`${styles.sec2} universal_gap`}
        style={{ marginBottom: "6rem" }}
      >
        <div
          className={styles.home_banner2}
          style={{
            maxWidth: "1240px",
            margin: "auto",
            padding: "4.375rem 1rem",
          }}
        >
          <img
            src="/images/home_sec2_img.png"
            alt="app"
            className={styles.sec2_laptop_img}
          />
          <div className={styles.sec2_box2}>
            {/* <h2>Why Digital Gold and Silver from BajajCapital</h2> */}
            <h2>Why Digital Gold and Silver from us?</h2>
            <p>
              Buy pure gold & silver securely—invest one-time or via SIP, sell
              anytime in one click, or convert to physical coins (as low as
              0.1g) with minimal making & delivery charges starting at just
              ₹200. Get doorstep delivery in 5–7 days!
            </p>
            <div className={styles.sec2_btn_container}>
              {testData?.map((item, i) => (
                <Link
                  to={token ? item.link : "/login"}
                  state={{ redirectTo: item.link }}
                >
                  <button className={`${styles.sec2_btn} universal_card`}>
                    {item.icon}
                    {item.name}
                  </button>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* SECTION3==== */}
      <div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            maxWidth: "752px",
            margin: "auto",
            padding: "1rem 0.5rem",
          }}
        >
          <h2>
            Want to See How Your Gold & Silver Savings will Grow? Calculate Now!
          </h2>
        </div>
        <div className="image-section">
          <div className="images-container">
            <img
              src="/images/augmandala.webp"
              alt="mandala"
              className="mandala-image"
            />
            <img
              src="/images/augmandala.webp"
              alt="mandala"
              className="mandala-image"
            />

            <div className="modal-box">
              <SipCalculator isGold={isGold} setIsGold={setIsGold} />
              <div className={styles.sec3_para}>
                Assuming rate of return 12%
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION4==== */}
      <section className={styles.sec4}>
        <div className={`universal_container ${styles.empanel_banner}`}>
          <div className={styles.sec4_box1}>
            <h3 className={styles.sec4_title}>Join the Gold Revolution!</h3>
            <p>
              Be part of this experience and explore a smarter way to build
              wealth. Let’s reimagine gold & silver investments together!
            </p>
            <div>
              <button
                onClick={() => navigate("/dashboard/gold/buy")}
                style={{
                  width: "164px",
                  maxHeight: "44px",
                  marginTop: "1.5rem",
                  color: "#221F1F",
                  border: "none",
                  borderRadius: "4px",
                  backgroundColor: "#FAFAFA",
                  padding: "7px 26px",
                  fontSize: "1rem",
                  fontWeight: "600",
                  transition:
                    "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 20px rgba(0, 0, 0, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                Invest Now
              </button>
            </div>
          </div>
          <div>
            <img
              // src="/images/home_sec4_img.png"
              // src="/images/testImg.png"
              src="/images/gold_coins.png"
              alt="gold_coins"
              className={styles.sec4_people_img}
            />
          </div>
        </div>
      </section>
      {/* SECTION5==== */}
      <section className={`universal_container ${styles.secure_main}`}>
        <div className={styles.container}>
          <img
            src="/images/augmandala.webp"
            alt="mandala"
            className={styles.rotatingImage}
          />
          <img
            src="/images/Augcoin.webp"
            alt="augmontCoin"
            className={styles.coinImage}
          />
          <img
            src="/images/Augcard.webp"
            alt="augmontCard"
            className={styles.cardImage}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            // maxWidth: "515px",
            width: "100%",
          }}
        >
          <h2>
            Start Your Golden Journey <br /> Today!
          </h2>
          <p>
            Secure, flexible, and effortless, your financial prosperity is just
            a tap away! Invest in Gold & Silver Today.
          </p>
          {/* <p>
            Secure, flexible, and effortless, your financial prosperity is just
            a tap away! Experience the BajajCapital Advantage – Invest in Gold &
            Silver Today.
          </p> */}
          <div className={styles.sec5_btn_container}>
            <CustomButton
              label="Buy Now"
              // onClick={() => navigate("/dashboard/gold/buy")}
              onClick={handleDelivery}
            />
          </div>
        </div>
      </section>
    </main>
  );
}
